import React, {Component} from 'react';
import {connect} from 'react-redux';
import * as actions from '../../actions/logout';
import {
  AUTH_SESSION_TOKEN,
  MESSAGE_EVENT_TYPE
} from "../../constants/postMessages";
import './index.scss';

export class Logout extends Component {
  logout = () => {
    if (sessionStorage.getItem(AUTH_SESSION_TOKEN)) {
      this.props.logout();
    }
  }

  componentDidMount() {
    window.addEventListener(MESSAGE_EVENT_TYPE, this.logout);
  }

  componentWillUnmount() {
    window.removeEventListener(MESSAGE_EVENT_TYPE, this.logout);
  }

  render() {
    return (<div/>);
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    logout: () => {
      dispatch(actions.logout());
    }
  }
};

export default connect(
    null,
    mapDispatchToProps
)(Logout);


// WEBPACK FOOTER //
// ./src/components/Logout/index.js